module.exports = __webpack_public_path__ + "img/rod_01.4fadb814.svg";